import React from 'react';
import { Link } from 'react-router-dom';
import './TopNavSection.scss';
import { urlFormatter } from '../../../util';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import Translation from 'services/translation.service';

const TopNavSection = (props) => {
  let disclaimerLink = urlFormatter(
    '/' + props.links['informative-disclaimer']['route']
  );
  let termsLink = urlFormatter('/' + props.links['informative-terms']['route']);
  let rightsLink = urlFormatter(
    '/' + props.links['informative-rights']['route']
  );
  // let lastIndex = props.location.pathname.lastIndexOf('/');
  let keys = props.location.pathname.split('/');
  let pageRoute = '';
  pageRoute = keys[2];

  return (
    <nav className="section-nav">
      <ul className="clear-list inline-list">
        <li className="section-nav-item">
          <Link
            to={disclaimerLink}
            className={
              'section-nav-lnk ' +
              (pageRoute === props.links['informative-disclaimer']['route']
                ? 'active'
                : '')
            }
          >
            {Translation.key('web_footer_last_disclmr')}
          </Link>
        </li>
        <li className="section-nav-item">
          <Link
            to={termsLink}
            className={
              'section-nav-lnk ' +
              (pageRoute === props.links['informative-terms']['route']
                ? 'active'
                : '')
            }
          >
            {Translation.key('web_footer_last_terms')}
          </Link>
        </li>
        <li className="section-nav-item">
          <Link
            to={rightsLink}
            className={
              'section-nav-lnk ' +
              (pageRoute === props.links['informative-rights']['route']
                ? 'active'
                : '')
            }
          >
            {Translation.key('web_footer_last_rights')}
          </Link>
        </li>
      </ul>
    </nav>
  );
};

const mapStateToProps = (state) => {
  return {
    links: state.layout.routes,
  };
};

export default connect(mapStateToProps, null)(withRouter(TopNavSection));
